import { useEffect } from "react";
import { VerticaisDataTable } from "src/components/vendas/VerticaisDataTable";
import { appStore } from "src/framework/store/AppStore";

const PAGE_TITLE = "Verticais"

const Verticais = () => {
    useEffect(() => {
        appStore.setPageTitle(PAGE_TITLE);
        return () => {
            appStore.setPageTitle("");
        }
    }, [])

    return (
        <div className="container">
            <div className="row">
                <div className="X12 grid-preco-perfil">
                    <VerticaisDataTable />
                </div>
            </div>
        </div>
    );
};

export { Verticais };
